import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  PageAbsolutePath,
  Journey,
  PageRelativePath
} from '../../../consts/Common';
import {
  calculateTotals,
  getSelectedProducts,
  //getNoOfInstallments,
  //getProductInstalmentTotalPriceByPaymentMethod,
  //getSelectedProducts,
  getSelectedVariant
} from '../../common/ProductMethods';
import {
  PaymentAssistBeginResponse,
  PaymentAssistCustomer,
  PaymentAssistRequest,
  ProductType,
  Totals
} from '../../common/CommonTypes';
import { PaymentMethod } from '../../common/Constants';
//import { Force24Helper } from '../../common/Force24Helper';
import { SiteContext } from '../../../context/SiteContext';
import PageHeader from '../../common/PageHeader';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { ButtonContinue } from '../../common/Button/ButtonContinue';
import Summary, {
  SummaryCustomerAcceptance
} from '../../common/Summary/Summary';
import { useJourney } from '../Layout';
import { useTranslation } from 'react-i18next';
import { PaymentApi } from '../../../api/PaymentApi';

const RenewalsSummary = (): JSX.Element => {
  const navigate = useNavigate();
  const { onPageChange, journey, onUpdateProducts } = useJourney();
  const { t } = useTranslation();

  const paymentOptionRequiredError = t('summary.payment-option-required-error');
  const buttonContinuePayment = t('summary.button-continue-payment');
  const buttonBackText = t('summary.button-back-text');

  const {
    personalDetail,
    vehicle,
    products,
    policyStartDate,
    singlePaymentDetails
  } = journey;

  const [agreedTermsAndConditions, setAgreedTermsAndConditions] =
    useState(false);

  const [error, setError] = useState('');

  //const noOfInstallments = getNoOfInstallments(products);
  const { site } = useContext(SiteContext);
  const { journeyType } = site;

  const cms = site.content.summaryPage;
  const isCallCenter = site.journeyType === Journey.CallCentre;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //let selectedQuotes: ProductType[] = [];
  //if (products && products !== undefined)
  //  selectedQuotes = getSelectedProducts(products);

  const updateQuotes = (
    variantId: string,
    quoteTypeId: number,
    paymentMethod: string
  ) => {
    const updated = products.map((q) =>
      q.productTypeId === quoteTypeId
        ? {
            ...q,
            selectedPaymentMethod: paymentMethod,
            productVariants: q.productVariants.map((variant) => {
              return {
                ...variant,
                isSelected: variant.variantId === variantId
              };
            })
          }
        : {
            ...q,
            selectedPaymentMethod: undefined,
            productVariants: q.productVariants.map((variant) => {
              return {
                ...variant,
                isSelected: false
              };
            })
          }
    );

    onUpdateProducts(updated);
  };

  const onBack = () => {
    if (isCallCenter === true) navigate(PageRelativePath.PersonalDetails);
    else navigate(PageRelativePath.Quote);
  };

  const selectedProducts = getSelectedProducts(products);
  const totals: Totals = calculateTotals(selectedProducts, 1);

  const callPaymentAssistRedirect = () => {
    const token = journey.token || site.user.token;

    const { billingAddress } = singlePaymentDetails;

    const selectedVariant = selectedProducts[0].productVariants.find(
      (v) => v.isSelected
    );

    const paymentInfo: PaymentAssistCustomer = {
      amount: totals.selectedTotalPrice,
      productVariant: selectedVariant?.variantId ?? '',
      surname: personalDetail.surname,
      firstName: personalDetail.firstName,
      address1: billingAddress.addressLine1 ?? '',
      address2: billingAddress.addressLine2 ?? '',
      city: billingAddress.townOrCity ?? '',
      postCode: billingAddress.postCode ?? '',
      county: billingAddress.region ?? '',
      phone: personalDetail.phone,
      email: personalDetail.email,
      vrn: vehicle?.vehicleDetails?.vrn ?? ''
    };

    const paymentAssistRequest: PaymentAssistRequest = {
      paymentInfo,
      site,
      journey,
      journeyType
    };

    const controller = new AbortController();

    const successCallback = (data: PaymentAssistBeginResponse) => {
      window.localStorage.setItem('redirectToPA', 'true');
      window.location.href = data.url;
    };

    const failureCallback = () => {
      console.log('failure');
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      navigate(PageRelativePath.PaymentAssistFailure, {
        relative: 'path'
      });
    };

    new PaymentApi().beginPaymentAssistRequest(
      paymentAssistRequest,
      token,
      successCallback,
      failureCallback,
      controller.signal
    );

    return () => {
      controller.abort();
    };
  };

  const onNext = () => {
    const selectedQuote = products.find((quote) => quote.isSelected === true);

    if (selectedQuote) {
      setError('');

      const selectedVariant = getSelectedVariant(selectedQuote.productVariants);

      if (selectedVariant) {
        if (selectedVariant.paymentMethod === PaymentMethod.Single) {
          navigate(PageRelativePath.SinglePayment);
        } else if (
          selectedVariant.paymentMethod === PaymentMethod.PaymentAssist
        ) {
          callPaymentAssistRedirect();
        } else {
          navigate(PageRelativePath.DirectDebit);
        }

        onPageChange(PageAbsolutePath.Renewals.Summary, true);
      } else {
        setError(paymentOptionRequiredError);
      }
    }
  };

  //useEffect(() => {
  //  const totals = selectedQuotes.map((quote) => {
  //    return getProductInstalmentTotalPriceByPaymentMethod(
  //      quote,
  //      PaymentMethod.Monthly,
  //      noOfInstallments,
  //      quote.selectedLinkedProducts || []
  //    );
  //  });

  //  const checkoutAmount = totals.reduce(
  //    (partialSum, t) => partialSum + t.firstInstallmentPrice,
  //    0
  //  );

  //  Force24Helper.updateTracker(formatNumber(checkoutAmount, 2));
  //}, [selectedQuotes]);

  const onNavigateToQuoteRemove = () => {
    const updatedProduct: ProductType[] = products.map((product) => ({
      ...product,
      selectedCoverLevelId: undefined,
      selectedPaymentMethod: undefined,
      selectedLinkedProducts: undefined,
      isSelected: false,
      productVariants: product.productVariants.map((variant) => ({
        ...variant,
        isSelected: false
      }))
    }));

    onUpdateProducts(updatedProduct);
  };

  const customerAcceptanceText: SummaryCustomerAcceptance = {
    sections: cms.acceptanceText
  };

  return (
    <div>
      <PageHeader
        title={cms.title}
        description={cms.description}
        information={cms.information}
        warning={cms.warning}
        descriptionClass='p2'
      />
      <div data-testid='container-form' className='form-left-border'>
        <Summary
          vehicle={vehicle}
          personalDetail={personalDetail}
          products={products}
          agreedTermsAndConditions={agreedTermsAndConditions}
          onUpdateAgreedTermsAndConditions={setAgreedTermsAndConditions}
          onPageChange={onPageChange}
          journeyType={site.journeyType}
          policyStartDate={policyStartDate}
          error={error}
          onNavigateToQuoteRemove={onNavigateToQuoteRemove}
          updateQuote={updateQuotes}
          isRenewals={true}
          showTermsAndConditions={!isCallCenter}
          personalDetailsPageUrl={PageRelativePath.PersonalDetails}
          vehiclePageUrl={PageRelativePath.VehicleDetails}
          productPageUrl={PageRelativePath.Quote}
          createPlanPageUrl=''
          customerAcceptanceText={customerAcceptanceText}
          customerAcceptanceSectionExpandedOnLoad={true}
          customerAcceptanceTickboxText={cms.acceptanceTickboxText}
          culture={site.cultureCode}
          renewalMarketingTickboxText={cms.consentToRenewalMarketingTickboxText}
          phoneNumberLabel={site.content.customerPage.phoneNumberLabel}
        />
      </div>
      <div className='flex-row form-nav'>
        <ButtonBack name='btnBack' onClick={onBack} text={buttonBackText} />
        <ButtonContinue
          name='btn-see-products'
          text={buttonContinuePayment}
          onClick={onNext}
          disabled={
            isCallCenter === false && agreedTermsAndConditions === false
          }
        />
      </div>
    </div>
  );
};

export default RenewalsSummary;
